export const firebaseConfig = {
    apiKey: "AIzaSyCjDUxq7ZllSLklcOk4PiEcx6Ov8Ka8F2M",
    authDomain: "covid-thinktank.firebaseapp.com",
    databaseURL: "https://covid-thinktank.firebaseio.com",
    projectId: "covid-thinktank",
    storageBucket: "covid-thinktank.appspot.com",
    messagingSenderId: "910922220971",
    appId: "1:910922220971:web:873e7b8b2cd91603107eee",
    measurementId: "G-Y2G05LP0FL"
  };
  export default firebaseConfig;